(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["casa-format-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__casaFormats) return;
    window.__casaFormats = true;

    const syncPanel = (panel) => {
      const closed = panel.hasAttribute('hidden');
      panel.querySelectorAll('input, textarea, select').forEach((el) => {
        el.disabled = closed;
      });
    };
    const initAll = (root) => (root || document).querySelectorAll('[data-casa-panel]').forEach(syncPanel);
    const markStarted = (form) => form && form.setAttribute('data-started', '');

    document.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-casa-toggle-btn]');
      if (!btn) return;
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      const opening = panel.hasAttribute('hidden');
      panel.toggleAttribute('hidden', !opening);
      btn.setAttribute('aria-expanded', String(opening));
      syncPanel(panel);
      markStarted(btn.closest('[data-casa-form]'));
    });

    document.addEventListener('input', (event) => {
      markStarted(event.target.closest('[data-casa-form]'));
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:block:select', (event) => initAll(event.target.closest('section') || document));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["group"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('expandable-toggle')) {
    const DURATION = 400;
    const MOBILE_QUERY = '(max-width: 749px)';

    class ExpandableToggle extends HTMLElement {
      connectedCallback() {
        // The group snippet renders no id on its root, so the root is found by the
        // unique class passed to it via the "class" param (fallback: nearest group).
        const root =
          document.querySelector('.group-block.expandable-' + this.dataset.blockId) ||
          this.closest('.group-block');
        if (!root) return;

        const content = root.querySelector(':scope > .group-block-content');
        if (!content) return;

        this.root = root;
        this.content = content;
        content.classList.add('expandable-content');

        // Put the toggle at the end of the root, i.e. below the clipped content wrapper.
        if (this.parentElement !== root) {
          root.appendChild(this); // re-triggers connectedCallback
          return;
        }

        this.button = this.querySelector('button');
        this.expanded = false;
        this.animating = false;

        this.onClick = () => this.toggle();
        this.onResize = () => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.refresh(), 150);
        };

        this.button.addEventListener('click', this.onClick);
        window.addEventListener('resize', this.onResize);
        // Images inside the group change its height when they finish loading.
        root.addEventListener('load', this.onResize, true);

        requestAnimationFrame(() => this.refresh());
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.onClick);
        window.removeEventListener('resize', this.onResize);
        if (this.root) this.root.removeEventListener('load', this.onResize, true);
        clearTimeout(this.resizeTimer);
        clearTimeout(this.animationTimer);
      }

      collapsedPx() {
        const isMobile = window.matchMedia(MOBILE_QUERY).matches;
        const percent = Number(isMobile ? this.dataset.collapsedMobile : this.dataset.collapsedDesktop);
        return Math.round((window.innerHeight * percent) / 100);
      }

      sync() {
        this.button.textContent = this.expanded ? this.dataset.lessLabel : this.dataset.moreLabel;
        this.button.setAttribute('aria-expanded', String(this.expanded));
      }

      refresh() {
        if (this.animating) return;
        const content = this.content;

        // Reset to the natural (fully open) state and measure it.
        content.classList.remove('expandable-content--clip');
        content.style.removeProperty('max-height');

        const collapsed = this.collapsedPx();
        if (content.scrollHeight <= collapsed + 1) {
          this.hidden = true;
          return;
        }

        this.hidden = false;
        this.sync();

        if (!this.expanded) {
          content.classList.add('expandable-content--clip');
          content.style.maxHeight = collapsed + 'px';
        }
      }

      toggle() {
        if (this.animating) return;
        if (this.expanded) {
          this.collapse();
        } else {
          this.expand();
        }
      }

      expand() {
        const content = this.content;
        this.expanded = true;
        this.animating = true;
        content.classList.add('expandable-content--clip', 'expandable-content--animating');
        content.style.maxHeight = content.scrollHeight + 'px';
        this.sync();

        this.animationTimer = setTimeout(() => {
          content.style.removeProperty('max-height');
          content.classList.remove('expandable-content--clip', 'expandable-content--animating');
          this.animating = false;
        }, DURATION + 50);
      }

      collapse() {
        const content = this.content;
        this.expanded = false;
        this.animating = true;
        content.classList.add('expandable-content--clip');

        // Pin the current height so the transition has a numeric starting point.
        content.style.maxHeight = content.offsetHeight + 'px';
        void content.offsetHeight;
        content.classList.add('expandable-content--animating');
        content.style.maxHeight = this.collapsedPx() + 'px';
        this.sync();

        if (this.root.getBoundingClientRect().top < 0) {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.root.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
        }

        this.animationTimer = setTimeout(() => {
          content.classList.remove('expandable-content--animating');
          this.animating = false;
        }, DURATION + 50);
      }
    }

    customElements.define('expandable-toggle', ExpandableToggle);
  }
  } catch(e) { console.error(e); }
})();

})();
